__turbopack_context__.v({
  "paper": "MCWklq_paper",
  "scroll": "MCWklq_scroll",
});
